import { AvailableLanguage } from '../i18n'

export const FLAGS_DICT: { [key in AvailableLanguage]: string } = {
	es: '🇦🇷',
	pt: '🇧🇷',
	en: '🇺🇸',
}
